import axios from 'axios';
import { token } from 'modules/token';

export function statusHandlerSuccess(response: any) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}
export function statusHandlerError(error: any) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error

  // Is request was cancelled, we do not want to show an error
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  if (error.response?.status === 401 || error.response?.status === 403) {
    let refresh_token = window.sessionStorage.getItem('refresh_token');
    let scope = window.sessionStorage.getItem('scope');
    if(refresh_token && scope) {
      token.getTokenByRefreshToken(scope!, refresh_token);
    }
  } else {
    console.log(error.message);
  }

  return Promise.reject(error);
}
